var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.51 20.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lager_1-2",
    "data-name": "Lager 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.25,20.51A10.26,10.26,0,1,1,20.51,10.25,10.27,10.27,0,0,1,10.25,20.51ZM10.25,1a9.26,9.26,0,1,0,9.26,9.25A9.26,9.26,0,0,0,10.25,1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.25,
    cy: 6.09,
    r: 2.12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_346",
    "data-name": "Path 346"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.69,9.85h3.13v6.7H8.69Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/NoImage.39cf706b49c73942ae17506b91173090.svg";
export { ForwardRef as ReactComponent };